export const topics = [
    [
        'Types of Variables', 
        'Converting Categorical Data to Numeric Data', 
        'Training, Validation, and Testing', 
        'Underfitting and Overfitting', 
        'Machine Learning Methods', 
        'Neural Networks'
    ],
    [
        'K-Means Clustering', 
        'Dimensionality Reduction', 
        'Autoencoders', 
        'Sparse Autoencoders',
        'Masked Representation Learning',
        'Reinforcement Learning',
        'On-Policy vs. Off-Policy RL',
        'Q-Learning',
        'Proximal Policy Optimization (PPO)',
        'Generative Flow Networks'
    ],
    [
        'Convolutional Neural Networks (CNNs)', 
        'FCNs and R-CNNs', 
        'Recurrent Neural Networks (RNNs)', 
        'Transformers', 
        'Vision Transformers',
        'Inductive Bias: CNNs vs Transformers', 
        'Graph Neural Networks',
        'Diffusion Models',
        'Generative Adversarial Networks', 
        'Transfer Learning'
    ],
    [
        'Tesla Self-Driving Cars', 
        'Image Generation', 
        'Neural Style Transfer',
        'Drug Discovery', 
        'Neural Radiance Fields', 
        'Adversarial Attacks', 
        'Code Generation',
        'AlphaGo'
    ],
    [
        'Reinforcement Learning: An Introduction (Sutton and Barto, 2020)',
        'Rectified Flow Transformers',
        'Online Learning'
    ]
];